/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingActualConfig } from '../../config/loading.config';
export interface ILoadingActualPluginMethods extends IPluginMethodMap {
  getLoadingActualSync(args?: any): any;
}

export class LoadingActualPlugin implements IAgentPlugin {
  readonly methods: ILoadingActualPluginMethods;

  constructor() {
    this.methods = {
      getLoadingActualSync: this.getLoadingActualSync.bind(this),
    };
  }

  getLoadingActualSync(args?: any) {
    return {
      loading: loadingActualConfig,
    };
  }
}
